import template from './operation-procedure.html';
import controller from './operation-procedure.controller';

const operationProcedureComponent = {
  bindings: {
    model: '=',
    onNewOp: '&',
    isOpen: '<'
  },
  template,
  controller
};

export default operationProcedureComponent;
